/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.AdminProfileSchema } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.role.code === 'admin',
    canAgent: currentUser && currentUser.role.code === 'agent',
    canPartner: currentUser && currentUser.role.code === 'partner',
    canSales: currentUser && currentUser.role.code === 'sales',
    canUser: currentUser && currentUser.role.code === 'user',

    canEditPartner:
      currentUser &&
      ['admin', 'agent', 'sales'].includes(currentUser.role.code),

    canMenuAgent:
      currentUser &&
      ['admin', 'agent', 'sales'].includes(currentUser.role.code),
  };
}
